<template>
  <div role="tablist" id="formCliente">
    <b-row class="pt-3">
      <b-col sm="9 title pl-0" id="titlePage">{{title || "Título não informado"}}</b-col>
      <b-col class="right pr-0 btnAcoesPag">
        <b-button variant="secondary" class="defaultColor" @click="confSairSemSalvar()"><i class="fas fa-arrow-left"></i> Voltar</b-button>
      </b-col>
      <b-col v-if="btnSalvar" class="right btnAcoesPag pr-0">
        <b-button class="btnSalvar" :style="cor" type="submit" value="Submit" @click="confirmaSalvar()"><i class="fas fa-save"></i> Salvar</b-button> <!--@click="salvarCliente()" -->
      </b-col>
    </b-row>
    <b-card no-body class="mb-1 shadow mt-2">
      <b-card-body>
        <b-container fluid class="p-0">
          <b-row>
            <b-col class="p-0 w-100">
              <b-alert v-model="showDismissibleAlert" variant="danger" dismissible class="w-100">
                Existem erros nos seguintes campos: <br />
                <div v-for="erro in this.errosLabels" :key="erro.message">{{erro.message}}</div>
              </b-alert>
              <b-row class="pt-3" id="headerCliente">
                <b-col md="7" class="pl-0">
                  <span><strong>Código:</strong> {{cliente.codCliente}}</span>
                </b-col>
                <b-col md="5">
                  <b-row>
                    <b-col class="p-0">
                      <b-form-checkbox  name="check-button" v-model="isJuridico" @change="changePJ" switch :disabled="desabilitado">
                        <b class="tipoPessoaWeb">{{tipoPessoaJ}}</b>
                        <b class="tipoPessoaMob">{{tipoPessoaJMobile}}</b>
                      </b-form-checkbox>
                    </b-col>
                    <b-col class="p-0">
                      <b-form-checkbox  name="check-button" v-model="isFisica" @change="changePF" switch :disabled="desabilitado">
                        <b class="tipoPessoaWeb">{{tipoPessoaF}}</b>
                        <b class="tipoPessoaMob">{{tipoPessoaFMobile}}</b>
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <form>
                <div class="form-row mt-4">
                  <div class="col-md-6 mb-3">
                    <b-form-group label="* Fantasia" label-for="cliFantasia">
                      <b-form-input autocomplete="no" id="cliFantasia" v-model="cliente.fantasia" size="sm" placeholder="Nome Fantasia" :disabled="desabilitado" v-validate="'required'" :class="{'input': true, 'invalid': errors.has('fantasia')}" name="fantasia"></b-form-input>
                      <span v-show="errors.has('fantasia')" class="invalid">{{ errors.first('fantasia') }}</span>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 mb-3">
                    <b-form-group label="* Razão Social" label-for="cliRazao">
                      <b-form-input autocomplete="no" id="cliRazao" v-model="cliente.razaoSocial" size="sm" placeholder="Razão Social" :disabled="desabilitado" v-validate="'required'" :class="{'input': true, 'invalid': errors.has('razao')}" name="razao"></b-form-input>
                      <span v-show="errors.has('razao')" class="invalid">O campo Razão Social é obrigatório</span>
                    </b-form-group>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-md-6 mb-3">
                    <b-form-group label="* CNPJ" label-for="cliCNPJ" v-if="this.cliente.tipo === 'J'">
                      <b-form-input autocomplete="no" id="cliCNPJ"  v-on:keyup="lengthCnpj()" v-model="cliente.cnpjCpf" size="sm" placeholder="CNPJ" :disabled="desabilitado" v-mask="'##.###.###/####-##'" v-validate="'required|min:18'" :class="{'input': true, 'invalid': errors.has('cnpj')}" name="cnpj"></b-form-input>
                      <span v-show="errors.has('cnpj')" class="invalid">Preenchimento obrigatório | Mínimo 14 caracteres</span>
                    </b-form-group>
                    <b-form-group label="* CPF" label-for="cliCPF" v-else>
                      <b-form-input autocomplete="no" id="cliCPF" v-model="cliente.cnpjCpf" size="sm" placeholder="CPF" :disabled="desabilitado" v-mask="'###.###.###-##'" v-validate="'required|min:14'" :class="{'input': true, 'invalid': errors.has('cpf')}" name="cpf"></b-form-input>
                      <span v-show="errors.has('cpf')" class="invalid">Preenchimento obrigatório | Mínimo 11 caracteres</span>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 mb-3">
                    <div class="form-row">
                      <div class="col-4" id="inputIe">
                        <b-form-group label="Insc. Est." label-for="cliIE">
                          <b-form-input autocomplete="no" id="cliIE" v-model="cliente.ieRg" v-if="this.cliente.tipo === 'J'" size="sm" placeholder="Inscrição Estadual" :disabled="desabilitado || desabilitadoIsento" type="number"></b-form-input> <!--v-mask="'###.###.###.###'" v-validate="'min:15'" :class="{'input': true, 'invalid': errors.has('ie')}" name="ie"-->
                          <b-form-input autocomplete="no" id="cliIE" :v-model="cliente.ieRg='ISENTO'" value="ISENTO" v-else size="sm" disabled></b-form-input>
                          <!-- <span v-show="errors.has('ie')" class="invalid">O campo Inscrição Estadual deve conter 12 caracteres</span> -->
                        </b-form-group>
                      </div>
                      <div class="col-2" id="checkIsento" v-if="this.cliente.tipo === 'J'">
                        <b-form-group label="Isento">
                          <b-form-checkbox
                            id="clienteIeIsento"
                            v-model="clienteIeIsento"
                            name="clienteIeIsento"
                            value="isento"
                            unchecked-value="nao"
                            :disabled="desabilitaIE"
                            @change="this.verifClienteIsento">
                          </b-form-checkbox>
                        </b-form-group>
                      </div>
                      <div class="col-2">
                        <b-form-group label="* DDD" label-for="cliDDD">
                          <b-form-input autocomplete="no" id="cliDDD" v-model="cliente.ddd" size="sm" placeholder="DDD" v-validate="'required|min:4'" v-mask="'(##)'" :class="{'input': true, 'invalid': errors.has('ddd')}" name="ddd"></b-form-input>
                          <span v-show="errors.has('ddd')" class="invalid">Preenchimento obrigatório | Deve conter 2 digitos</span>
                        </b-form-group>
                      </div>
                      <div class="col-4" v-if="this.cliente.tipo === 'J'">
                        <b-form-group label="* Telefone" label-for="cliTelefone">
                          <b-form-input autocomplete="no" id="cliTelefone" v-model="cliente.telefone" size="sm" placeholder="Telefone" v-validate="'required|min:9'" v-mask="['####-####', '#####-####']" :class="{'input': true, 'invalid': errors.has('telefone')}" name="telefone"></b-form-input>
                          <span v-show="errors.has('telefone')" class="invalid">Preenchimento obrigatório | Mínimo 8 digitos</span>
                        </b-form-group>
                      </div>
                      <div class="col-6" v-else>
                        <b-form-group label="* Telefone" label-for="cliTelefone">
                          <b-form-input autocomplete="no" id="cliTelefone" v-model="cliente.telefone" size="sm" placeholder="Telefone" v-validate="'required|min:9'" v-mask="['####-####', '#####-####']" :class="{'input': true, 'invalid': errors.has('telefone')}" name="telefone"></b-form-input>
                          <span v-show="errors.has('telefone')" class="invalid">Preenchimento obrigatório | Mínimo 8 digitos</span>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-row mb-5">
                  <div class="col-md-6 mb-3">
                    <label for="input-tabelaPreco">* Tabela de Preço</label>
                    <model-list-select
                      id="input-tabelaPreco"
                      :list="dadosTabela.tabelasPreco"
                      v-model="cliente.tabelaPreco"
                      option-value="codigo"
                      option-text="descricao"
                      placeholder="Selecione ou digite para pesquisar"
                      class="selectStyle">
                    </model-list-select>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label for="input-tabelaPreco">Condição de Pagamento</label>
                    <model-list-select
                      id="input-tabelaPreco"
                      :list="dadosTabela.condPagtos"
                      v-model="cliente.condPagto"
                      option-value="codigo"
                      option-text="descricao"
                      placeholder="Selecione ou digite para pesquisar"
                      class="selectStyle">
                    </model-list-select>
                  </div>
                </div>
                <div class="form-row mb-5">
                  <b-col>
                    <b-row class="mb-3">
                      <b-col md="10" class="titleFluid"><p>CONTATOS</p></b-col>
                      <b-col md="2" class="p-0 txtRight"><b-button variant="secondary" class="col-md-8 defaultColor" @click="newContato()"><i class="fas fa-plus"></i> Novo</b-button></b-col>
                      <!-- <b-col md="1" class="p-0 txtRight btnAdd">
                        <b-button variant="secondary" class="offset-1 btn-circle defaultColor" @click="newContato()"><i class="fas fa-plus"></i></b-button>
                      </b-col> -->
                    </b-row>
                    <b-row>
                      <b-table bordered hover :items="cliente.contatos" :fields="fieldsContatos" v-show="verifLenghtArray(cliente.contatos)">
                        <template slot="actionAcoes" slot-scope="row">
                          <b-navbar-nav>
                            <b-nav-item-dropdown>
                              <template slot="button-content"><i class="fas fa-cog"></i></template>
                              <b-dropdown-item @click="alterContato(row.index)">Editar / Ver Detalhes</b-dropdown-item>
                              <b-dropdown-item @click="askExcluirContato(row.index)">Excluir</b-dropdown-item>
                            </b-nav-item-dropdown>
                          </b-navbar-nav>
                        </template>
                      </b-table>
                    </b-row>
                  </b-col>
                </div>
                <div class="form-row mb-5">
                  <b-col>
                    <b-row class="mb-3">
                      <b-col md="10" class="titleFluid"><p>ENDEREÇOS</p></b-col>
                      <b-col md="2" class="p-0 txtRight"><b-button variant="secondary" class="col-md-8 defaultColor" @click="newEndereco()"><i class="fas fa-plus"></i> Novo</b-button></b-col>
                      <!-- <b-col md="1" class="p-0 txtRight btnAdd"><b-button variant="secondary" class="btn-circle defaultColor" @click="newEndereco()"><i class="fas fa-plus"></i></b-button></b-col> -->
                    </b-row>
                    <b-row>
                      <b-table bordered hover :items="cliente.enderecos" :fields="fieldsEnderecos" v-show="verifLenghtArray(cliente.enderecos)">
                        <template slot="actionAcoes" slot-scope="row">
                          <b-navbar-nav>
                            <b-nav-item-dropdown>
                              <template slot="button-content"><i class="fas fa-cog"></i></template>
                              <b-dropdown-item @click="alterEndereco(row.index)">Editar / Ver Detalhes</b-dropdown-item>
                              <b-dropdown-item @click="askExcluirEndereco(row.index)">Excluir</b-dropdown-item>
                            </b-nav-item-dropdown>
                          </b-navbar-nav>
                        </template>
                      </b-table>
                    </b-row>
                  </b-col>
                </div>
                <div class="form-row mb-5">
                  <b-col>
                    <b-row class="mb-3">
                      <b-col md="10" class="titleFluid"><p>E-MAILS</p></b-col>
                      <b-col md="2" class="p-0 txtRight"><b-button variant="secondary" class="col-md-8 defaultColor" @click="newEmail()"><i class="fas fa-plus"></i> Novo</b-button></b-col>
                      <!-- <b-col md="1" class="p-0 txtRight btnAdd"><b-button variant="secondary" class="btn-circle defaultColor" @click="newEmail()"><i class="fas fa-plus"></i></b-button></b-col> -->
                    </b-row>
                    <b-row>
                      <b-table bordered hover :items="cliente.emails" :fields="fieldsEmails" v-show="verifLenghtArray(cliente.emails)">
                        <template slot="actionAcoes" slot-scope="row">
                          <b-navbar-nav>
                            <b-nav-item-dropdown>
                              <template slot="button-content"><i class="fas fa-cog"></i></template>
                              <b-dropdown-item @click="alterEmail(row.index)">Editar / Ver Detalhes</b-dropdown-item>
                              <b-dropdown-item @click="askExcluirEmail(row.index)">Excluir</b-dropdown-item>
                            </b-nav-item-dropdown>
                          </b-navbar-nav>
                        </template>
                      </b-table>
                    </b-row>
                  </b-col>
                </div>
                <div class="form-row mb-5">
                  <b-col>
                    <b-row class="mb-3">
                      <b-col md="10" class="titleFluid"><p>REFERÊNCIAS COMERCIAIS</p></b-col>
                      <b-col md="2" class="p-0 txtRight"><b-button variant="secondary" class="col-md-8 defaultColor" @click="newReferencia()"><i class="fas fa-plus"></i> Novo</b-button></b-col>
                      <!-- <b-col md="1" class="p-0 txtRight btnAdd"><b-button variant="secondary" class="btn-circle defaultColor" @click="newReferencia()"><i class="fas fa-plus"></i></b-button></b-col> -->
                    </b-row>
                    <b-row>
                      <b-table bordered hover :items="cliente.referenciasComerciais" :fields="fieldsReferencias" v-show="verifLenghtArray(cliente.referenciasComerciais)">
                        <template slot="actionAcoes" slot-scope="row">
                          <b-navbar-nav>
                            <b-nav-item-dropdown>
                              <template slot="button-content"><i class="fas fa-cog"></i></template>
                              <b-dropdown-item @click="alterReferencia(row.index)">Editar / Ver Detalhes</b-dropdown-item>
                              <b-dropdown-item @click="askExcluirReferencia(row.index)">Excluir</b-dropdown-item>
                            </b-nav-item-dropdown>
                          </b-navbar-nav>
                        </template>
                      </b-table>
                    </b-row>
                  </b-col>
                </div>
                <div class="form-row mb-5">
                  <b-col>
                    <b-row class="mb-3">
                      <b-col md="12" class="titleFluid"><p>LIMITE DE CRÉDITO</p></b-col>
                    </b-row>
                    <div class="form-row" id="boxLimite">
                      <div class="col-md-6">
                        <strong>Valor Total</strong><br>
                        <p class="m-0">R$ {{formatterValue(cliente.limiteCredito)}}</p>
                      </div>
                      <div class="col-md-6">
                        <strong>Valor Usado</strong><br>
                        <p class="m-0">R$ {{formatterValue(cliente.valorUtilizado)}}</p>
                      </div>
                    </div>
                    <b-row v-show="verifLenghtArray(cliente.duplicatasEmAberto)">
                      <span><strong>Duplicatas em Aberto</strong></span>
                      <b-table bordered hover :items="cliente.duplicatasEmAberto" :fields="fieldsDuplicatas" />
                    </b-row>
                  </b-col>
                </div>
                <div class="form-row mb-3">
                  <b-col>
                    <b-row class="mb-3">
                      <b-col md="12" class="titleFluid"><p>ÚLTIMOS PEDIDOS</p></b-col>
                    </b-row>
                    <b-row>
                      <b-table bordered hover :items="cliente.ultimosPedidos" :fields="fieldsUltPed" v-if="verifLenghtArray(cliente.ultimosPedidos)" />
                      <span v-else class="w-100" id="semPedidos">Este cliente ainda não realizou pedidos</span>
                    </b-row>
                  </b-col>
                </div>
              </form>
            </b-col>
          </b-row>
        </b-container>
      </b-card-body>
    </b-card>
    <!-- MODAIS -->
    <!--modalContato-->
    <b-modal
      v-model="modalContato"
      ok-title="Salvar"
      ok-variant="primary"
      :ok-disabled=disableSalvarContato()
      cancel-title="Fechar"
      cancel-variant="secondary"
      @ok="addCont"
      :no-close-on-esc=true
      :no-close-on-backdrop=true
      :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant">
      <template slot="modal-header" :style="cor">
        <h5 v-if="this.novoContato">Novo Contato</h5>
        <h5 v-else>Editar Contato</h5>
      </template>
      <form autocomplete="false">
        <b-form-group label="* Nome" label-for="cliNomeContato" class="mt-2">
          <b-form-input autocomplete="false" id="cliNomeContato" v-model="contato.nome" size="sm" placeholder="Nome do Contato" v-validate="'required'" name="nmCnt" :class="{'input': true, 'invalid': errors.has('nmCnt')}"></b-form-input>
          <span v-show="errors.has('nmCnt')" class="invalid">Preenchimento obrigatório</span>
        </b-form-group>
        <b-form-group label="* Email" label-for="cliEmailContato" class="mt-2">
          <b-form-input autocomplete="nope" id="cliEmailContato" v-model="contato.email" type="text" size="sm" placeholder="exemplo@contato.com.br" v-validate="'required|email'" name="emlCnt" :class="{'input': true, 'invalid': errors.has('emlCnt')}" v-on:keyup="changeEmail(errors.has('emlCnt'))"></b-form-input> <!-- :disabled="desabilitado" -->
          <span v-show="errors.has('emlCnt')" class="invalid">Preenchimento obrigatório | Digite um email válido</span>
        </b-form-group>
        <div class="form-row mt-2">
          <div class="col-md-12">
            <div class="form-row">
              <div class="col-12">
                <b-form-group label="Data Nasc.:" label-for="cliNascContato">
                  <div class="datepicker-container with-button">
                    <div class="datepicker-trigger">
                      <input name="date_limit" :value="this.dataAtual" type="hidden">
                      <b-form-input autocomplete="false" name="brth_dt" v-mask="'##/##/####'" v-validate="'after:01/01/1900|before:02/05/2019|date_format:dd/MM/yyyy'" data-vv-as="Birth day" type="text" v-model="contato.dataNascFormat" size="sm" placeholder="Data de Nascimento" :class="{'input': true, 'invalid': errors.has('brth_dt')}"></b-form-input>
                      <span v-show="errors.has('brth_dt')" class="invalid">Digite uma data válida</span>
                    </div>
                  </div>
                </b-form-group>
              </div>
            </div>
            <div class="form-row mt-2">
              <div class="col-4">
                <b-form-group label="* DDD" label-for="cliDDDContato">
                  <b-form-input autocomplete="no" id="cliDDDContato" v-model="contato.ddd" size="sm" placeholder="(00)" v-validate="'required|min:4'" v-mask="'(##)'" name="dddCnt" :class="{'input': true, 'invalid': errors.has('dddCnt')}"></b-form-input><!-- :disabled="desabilitado" -->
                </b-form-group>
                <span v-show="errors.has('dddCnt')" class="invalid mt-2">Preenchimento obrigatório | Deve conter 2 digitos</span>
              </div>
              <div class="col-8">
                <b-form-group label="* Telefone" label-for="cliTelefoneContato">
                  <b-form-input autocomplete="no" id="cliTelefoneContato" v-model="contato.telefone" size="sm" placeholder="0000-0000 ou 00000-0000" v-validate="'required|min:9'" v-mask="['####-####', '#####-####']" name="telCnt" :class="{'input': true, 'invalid': errors.has('telCnt')}"></b-form-input>
                </b-form-group>
                <span v-show="errors.has('telCnt')" class="invalid">Preenchimento obrigatório | Mínimo 8 digitos</span>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-2">
          <label>* Tipo de Contato</label>
          <model-list-select :list="dadosTabela.tipoContatos" v-model="contato.tipoContato" option-value="codigo" option-text="descricao" placeholder="Selecione ou digite para pesquisar" class="selectStyle"></model-list-select> <!-- :isDisabled="!novoContato" -->
        </div>
      </form>
    </b-modal>
    <!--modalEndereco-->
    <b-modal
      v-model="modalEndereco"
      ok-title="Salvar"
      ok-variant="primary"
      :ok-disabled=disableSalvarEndereco()
      cancel-title="Fechar"
      cancel-variant="secondary"
      @ok="addEnd"
      :no-close-on-esc=true
      :no-close-on-backdrop=true
      :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant">
      <template slot="modal-header">
        <h5 v-if="this.novoEndereco">Novo Endereço</h5>
        <h5 v-else>Editar Endereço</h5>
      </template>
      <form>
        <div class="form-row">
          <div class="col-md-12">
            <div class="form-row">
              <div class="col-12">
                <b-form-group label="* Cep" label-for="cliEndCep">
                  <b-form-input autocomplete="no" id="cliEndCep" v-model="endereco.cep" size="sm" placeholder="00000-000" v-validate="'required|min:9'" v-mask="'#####-###'" :class="{'input': true, 'invalid': errors.has('cepEndereco')}" name="cepEndereco"></b-form-input> <!-- :disabled="desabilitado" -->
                  <span v-show="errors.has('cepEndereco')" class="invalid">Preenchimento obrigatório | Deve conter 8 digitos</span>
                </b-form-group>
              </div>
            </div>
            <div class="form-row mt-2">
              <div class="col-12">
                <b-form-group label="* Logradouro" label-for="cliEndLog">
                  <b-form-input autocomplete="no" id="cliEndLog" v-model="endereco.logradouro" size="sm" placeholder="Rua, Avenida, etc..." v-validate="'required'" :class="{'input': true, 'invalid': errors.has('logradouroEndereco')}" name="logradouroEndereco"></b-form-input> <!-- :disabled="desabilitado" -->
                  <span v-show="errors.has('logradouroEndereco')" class="invalid">Preenchimento obrigatório</span>
                </b-form-group>
              </div>
            </div>
            <div class="form-row mt-2">
              <div class="col-4">
                <b-form-group label="* Número" label-for="cliEndNum">
                  <b-form-input autocomplete="no" id="cliEndNum" v-model="endereco.numero" size="sm" placeholder="000" type="number" v-validate="'required'" :class="{'input': true, 'invalid': errors.has('numeroEndereco')}" name="numeroEndereco"></b-form-input> <!-- :disabled="desabilitado" -->
                  <span v-show="errors.has('numeroEndereco')" class="invalid">Preenchimento obrigatório</span>
                </b-form-group>
              </div>
              <div class="col-8">
                <b-form-group label="Complemento" label-for="cliEndComp">
                  <b-form-input autocomplete="no" id="cliEndComp" v-model="endereco.complemento" size="sm" placeholder="Ex.: Casa 1 / Apartamento 1"></b-form-input> <!-- :disabled="desabilitado" -->
                </b-form-group>
              </div>
            </div>
            <div class="form-row mt-2">
              <div class="col-3">
                <b-form-group label="* Estado" label-for="cliEndEst">
                  <b-form-select size="sm" v-model="endereco.uf">
                    <template slot="first">
                        <option :value="null" disabled>-- Estado --</option>
                    </template>
                    <option v-for="(uf, key) in options" :value="uf" :key="key">
                        {{uf}}
                    </option>
                  </b-form-select>
                </b-form-group>
              </div>
              <div class="col-4">
                <b-form-group label="Bairro" label-for="cliEndBairro">
                  <b-form-input autocomplete="no" id="cliEndBairro" v-model="endereco.bairro" size="sm" placeholder="Bairro"></b-form-input> <!-- :disabled="desabilitado" -->
                </b-form-group>
              </div>
              <div class="col-5">
                <b-form-group label="* Cidade" label-for="cliEndCid">
                  <b-form-input autocomplete="no" id="cliEndCid" v-model="endereco.cidade" size="sm" placeholder="Cidade" v-validate="'required'" :class="{'input': true, 'invalid': errors.has('cidadeEndereco')}" name="cidadeEndereco"></b-form-input> <!-- :disabled="desabilitado" -->
                  <span v-show="errors.has('cidadeEndereco')" class="invalid">Preenchimento obrigatório</span>
                </b-form-group>
              </div>
            </div>
            <div class="mt-2">
              <label>* Tipo End.</label>
              <model-list-select :list="dadosTabela.tipoEnderecos" v-model="endereco.tipoEndereco" option-value="codigo" option-text="descricao" placeholder="Selecione ou digite para pesquisar" class="selectStyle"></model-list-select> <!--:isDisabled="!novoEndereco"-->
            </div>
          </div>
        </div>
      </form>
    </b-modal>
    <!--modalEmail-->
    <b-modal
      v-model="modalEmail"
      ok-title="Salvar"
      ok-variant="primary"
      :ok-disabled=disableSalvarEmail()
      cancel-title="Fechar"
      cancel-variant="secondary"
      @ok="addEmail"
      :no-close-on-esc=true
      :no-close-on-backdrop=true
      :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant">
      <template slot="modal-header">
        <h5 v-if="this.novoEmail">Novo E-mail</h5>
        <h5 v-else>Editar E-mail</h5>
      </template>
      <form>
        <div class="form-row">
          <label>* Tipo E-mail</label>
          <model-list-select :list="dadosTabela.tipoEmails" v-model="email.tipoEmail" option-value="codigo" option-text="descricao" placeholder="Selecione ou digite para pesquisar" class="selectStyle"></model-list-select> <!-- :isDisabled="!novoEmail" -->
        </div>
        <div class="form-row mt-2">
          <b-form-group label="* Email" label-for="cliEmail" class="w-100">
            <b-form-input type="text" id="cliEmail" v-model="email.email" size="sm" placeholder="exemplo@email.com.br" v-validate="'required|email'" :class="{'input': true, 'invalid': errors.has('inputEmail')}" name="inputEmail" v-on:keyup="changeEmail(errors.has('inputEmail'))"></b-form-input> <!-- :disabled="desabilitado" -->
            <span v-show="errors.has('inputEmail')" class="invalid">Preenchimento obrigatório | Digite um email válido</span>
          </b-form-group>
        </div>
      </form>
    </b-modal>
    <!--modalReferencia-->
    <b-modal
      v-model="modalReferencia"
      ok-title="Salvar"
      ok-variant="primary"
      :ok-disabled=disableSalvarReferencia()
      cancel-title="Fechar"
      cancel-variant="secondary"
      @ok="addRef"
      :no-close-on-esc=true
      :no-close-on-backdrop=true
      :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant">
      <template slot="modal-header">
        <h5 v-if="this.novaReferencia">Nova Referência Comercial</h5>
        <h5 v-else>Editar Referência Comercial</h5>
      </template>
      <form autocomplete="false">
        <div class="form-row">
          <div class="col-md-12">
            <b-form-group label="* Nome" label-for="cliNomeRef" class="w-100">
              <b-form-input autocomplete="false" id="cliNomeRef" v-model="referencia.nome" size="sm" placeholder="Nome" v-validate="'required'" name="nmRf" :class="{'input': true, 'invalid': errors.has('nmRf')}"></b-form-input> <!-- :disabled="desabilitado" -->
              <span v-show="errors.has('nmRf')" class="invalid">Preenchimento obrigatório</span>
            </b-form-group>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-md-12">
            <b-form-group label="* Email" label-for="cliEmailRef" class="w-100">
              <b-form-input autocomplete="nope" type="text" id="cliEmailRef" v-model="referencia.email" size="sm" placeholder="exemplo@referencia.com.br" v-validate="'required|email'" name="emlRef" :class="{'input': true, 'invalid': errors.has('emlRef')}" v-on:keyup="changeEmail(errors.has('emlRef'))"></b-form-input> <!-- :disabled="desabilitado" -->
              <span v-show="errors.has('emlRef')" class="invalid">Preenchimento obrigatório | Digite um email válido</span>
            </b-form-group>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-3">
            <b-form-group label="* DDD" label-for="cliDDDRef">
              <b-form-input autocomplete="no" id="cliDDDRef" v-model="referencia.ddd" size="sm" placeholder="(00)" v-validate="'required|min:4'" v-mask="'(##)'" name="dddReferencia" :class="{'input': true, 'invalid': errors.has('dddReferencia')}"></b-form-input><!-- :disabled="desabilitado" -->
              <span v-show="errors.has('dddReferencia')" class="invalid">Preenchimento obrigatório | Deve conter 2 digitos</span>
            </b-form-group>
          </div>
          <div class="col-9">
            <b-form-group label="* Telefone" label-for="cliTelefoneRef">
              <b-form-input autocomplete="no" id="cliTelefoneRef" v-model="referencia.telefone" size="sm" placeholder="0000-0000 ou 00000-0000" v-validate="'required|min:9'" v-mask="['####-####', '#####-####']" name="telefoneReferencia" :class="{'input': true, 'invalid': errors.has('telefoneReferencia')}"></b-form-input>
              <span v-show="errors.has('telefoneReferencia')" class="invalid">Preenchimento obrigatório | Mínimo 8 digitos</span>
            </b-form-group>
          </div>
        </div>
      </form>
    </b-modal>
    <!--modalClienteExist-->
    <b-modal
      v-model="modalClienteExist"
      ok-variant="primary"
      ok-only
      @ok="dadosCliExist"
      :no-close-on-esc=true
      :no-close-on-backdrop=true
      :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant">
      <template slot="modal-header">
        <h5>Cliente Existente</h5>
      </template>
      <span>Já existe um cliente com este CNPJ cadastrado no sistema!! <br/> Os dados serão exibidos a seguir</span>
    </b-modal>
    <!--modalConfSairSemSalvar-->
    <b-modal
      v-model="modalConfSairSemSalvar"
      ok-title="Sim"
      ok-variant="primary"
      cancel-title="Não"
      @ok="pageLista"
      :no-close-on-esc=true
      :no-close-on-backdrop=true
      :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant">
      <template slot="modal-header">
        <h5>Sair sem Salvar</h5>
      </template>
      <span>Tem certeza que deseja sair sem salvar as alterações neste cliente?</span>
    </b-modal>
    <!--modalConfSalvarCliente-->
    <b-modal
      v-model="modalConfSalvarCliente"
      ok-title="Salvar"
      ok-variant="primary"
      cancel-title="Não"
      @ok="salvarCliente"
      :no-close-on-esc=true
      :no-close-on-backdrop=true
      :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant">
      <template slot="modal-header">
        <h5>Salvar</h5>
      </template>
      <span>Tem certeza de que deseja salvar este cliente?</span>
    </b-modal>
    <!--modalClienteSalvo-->
    <b-modal
      v-model="modalClienteSalvo"
      ok-variant="primary"
      ok-only
      @ok="pageLista"
      :no-close-on-esc=true
      :no-close-on-backdrop=true
      :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant">
      <template slot="modal-header">
        <h5>Salvo</h5>
      </template>
      <span>Cliente Salvo com sucesso!</span>
    </b-modal>
    <!--modalExcluirContato-->
    <b-modal
      v-model="modalExcluirContato"
      ok-variant="primary"
      cancel-title="Cancelar"
      @ok="excluirContato"
      :no-close-on-esc=true
      :no-close-on-backdrop=true
      :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant">
      <template slot="modal-header">
        <h5>Excluir</h5>
      </template>
      <span>Tem certeza de que deseja exluir este Contato? Esta ação não poderá ser desfeita!</span>
    </b-modal>
    <!--modalExcluirEndereco-->
    <b-modal
      v-model="modalExcluirEndereco"
      ok-variant="primary"
      cancel-title="Cancelar"
      @ok="excluirEndereco"
      :no-close-on-esc=true
      :no-close-on-backdrop=true
      :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant">
      <template slot="modal-header">
        <h5>Excluir</h5>
      </template>
      <span>Tem certeza de que deseja exluir este Endereço? Esta ação não poderá ser desfeita!</span>
    </b-modal>
    <!--modalExcluirEmail-->
    <b-modal
      v-model="modalExcluirEmail"
      ok-variant="primary"
      cancel-title="Cancelar"
      @ok="excluirEmail"
      :no-close-on-esc=true
      :no-close-on-backdrop=true
      :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant">
      <template slot="modal-header">
        <h5>Excluir</h5>
      </template>
      <span>Tem certeza de que deseja exluir este Email? Esta ação não poderá ser desfeita!</span>
    </b-modal>
    <!--modalExcluirReferencia-->
    <b-modal
      v-model="modalExcluirReferencia"
      ok-variant="primary"
      cancel-title="Cancelar"
      @ok="excluirReferencia"
      :no-close-on-esc=true
      :no-close-on-backdrop=true
      :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant">
      <template slot="modal-header">
        <h5>Excluir</h5>
      </template>
      <span>Tem certeza de que deseja exluir esta Referência? Esta ação não poderá ser desfeita!</span>
    </b-modal>
    <!--modalItemExcluido-->
    <b-modal
      v-model="modalItemExcluido"
      ok-variant="primary"
      ok-only
      :no-close-on-esc=true
      :no-close-on-backdrop=true
      :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant">
      <template slot="modal-header">
        <h5>Excluído</h5>
      </template>
      <span>Registro excluído com sucesso!</span>
    </b-modal>
    <!-- /MODAIS -->
  </div>
</template>
<script>
  import { broadcastServer, operacao, modo } from '@/main'
  import { ModelListSelect } from 'vue-search-select'
  import clienteService from '@/services/tableClientes'
  import { TheMask, mask } from 'vue-the-mask'
  import { mapState } from 'vuex'
  export default {
    name: 'TableClientesVue',
    props: ['title'],
    components: {
      ModelListSelect,
      TheMask
    },
    directives: {mask},
    computed: {
      ...mapState({
        cor: state => {
          const { cor } = state.cor
          // console.log(cor)
          return {
            'background-color': cor
          }
        },
        corSelecionado: state => {
          const { corSelecionado } = state.cor
          // console.log(corSelecionado)
          return {
            'background-color': corSelecionado
          }
        }
      })
    },
    data () {
      return {
        dataAtual: '',
        filterTipoEnd: [],
        filterTipoEmail: [],
        showDismissibleAlert: false,
        errosLabels: [],
        dateFormat: 'D MMM',
        inputDateOne: '',
        inputDateTwo: '',
        buttonDateOne: '',
        buttonDateTwo: '',
        inlineDateOne: '',
        sundayDateOne: '',
        sundayFirst: false,
        alignRight: false,
        trigger: false,
        termo: '',
        dataDe: '',
        dataAte: '',
        uf: null,
        options: [
          'AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN', 'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO'
        ],
        cliente: {
          tipo: 'J',
          contatos: [],
          enderecos: [],
          emails: [],
          referenciasComerciais: [],
          duplicatasEmAberto: [],
          ultimosPedidos: [],
          tabelaPreco: {},
          condPagto: '',
          limiteCredito: '',
          valorUtilizado: ''
        },
        dadosTabela: {
          tabelasPreco: [],
          condPagtos: [],
          tipoContatos: [],
          tipoEnderecos: [],
          tipoEmails: []
        },
        checked: 'Jurídica',
        clienteIeIsento: false,
        selected: null,
        isJuridico: true,
        isFisica: false,
        headerTextVariant: 'light',
        headerBgVariant: 'dark',
        btnSalvar: true,
        modalCont: false,
        text: '',
        desabilitado: false,
        desabilitadoIsento: false,
        tipoPessoaJ: 'Pessoa Juridica',
        tipoPessoaF: 'Pessoa Física',
        tipoPessoaJMobile: 'PJ',
        tipoPessoaFMobile: 'PF',
        clienteExistente: {},
        indiceArrayContato: '',
        indiceArrayEndereco: '',
        indiceArrayEmail: '',
        indiceArrayReferencia: '',
        modalConfSairSemSalvar: false,
        modalConfSalvarCliente: false,
        modalClienteSalvo: false,
        modalClienteExist: false,
        modalExcluirContato: false,
        modalExcluirEndereco: false,
        modalExcluirEmail: false,
        modalExcluirReferencia: false,
        modalItemExcluido: false,
        modalContato: false,
        modalEndereco: false,
        modalEmail: false,
        modalReferencia: false,
        novoContato: false,
        novoEndereco: false,
        novoEmail: false,
        novaReferencia: false,
        indiceContatoSelecionado: -1,
        indiceEnderecoSelecionado: -1,
        emailTemErros: true,
        incluirContato: false,
        contato: {
          dataNasc: '',
          telefone: '',
          ddd: '',
          tipoContato: {
            codigo: '',
            chaveErp: '',
            deletado: 0,
            descricao: ''
          },
          dataNascFormat: '',
          chaveErp: '',
          nome: '',
          email: '',
          codCliente: ''
        },
        endereco: {
          uf: '',
          cidade: '',
          complemento: '',
          numero: '',
          bairro: '',
          logradouro: '',
          latitude: 0,
          chaveErp: '',
          tipoEndereco: {
            principal: 0,
            codigo: '',
            chaveErp: '',
            deletado: 0,
            descricao: ''
          },
          enderecoCompleto: '',
          cep: '',
          longitude: 0
        },
        email: {
          tipoEmail: {
            principal: 0,
            codigo: '',
            chaveErp: '',
            deletado: 0,
            descricao: ''
          },
          chaveErp: '',
          email: ''
        },
        referencia: {
          telefone: '',
          ddd: '',
          chaveErp: '',
          nome: '',
          email: ''
        },
        fieldsContatos: [
          {
            key: 'nome',
            label: 'Nome',
            class: 'cliContNome',
            formatter: this.toCapitalize
          },
          {
            key: 'email',
            label: 'Email',
            class: 'cliContEmail',
            formatter: this.toLowerCase
          },
          {
            key: 'ddd',
            label: 'DDD',
            class: 'cliContDDD'
          },
          {
            key: 'telefone',
            label: 'Telefone',
            class: 'cliContTel'
          },
          {
            key: 'tipoContato.descricao',
            label: 'Tipo',
            class: 'cliContTipo'
          },
          {
            label: 'Ações',
            key: 'actionAcoes',
            class: 'columnActions'
          }
        ],
        fieldsEnderecos: [
          {
            key: 'enderecoCompleto',
            label: 'Endereço',
            class: 'cliEnd',
            formatter: this.toCapitalize
          },
          {
            key: 'tipoEndereco.descricao',
            label: 'Tipo',
            class: 'cliEndTipo'
          },
          {
            key: 'tipoEndereco.principal',
            label: 'Principal',
            formatter: value => {
              return (value === 1 ? 'Sim' : 'Não')
            },
            class: 'cliEndPrinc txtCenter'
          },
          {
            label: 'Ações',
            key: 'actionAcoes',
            class: 'columnActions'
          }
        ],
        fieldsEmails: [
          {
            key: 'email',
            label: 'Email',
            class: 'cliEmail',
            formatter: this.toLowerCase
          },
          {
            key: 'tipoEmail.descricao',
            label: 'Tipo',
            class: 'cliEmailTipo'
          },
          {
            key: 'tipoEmail.principal',
            label: 'Principal',
            formatter: value => {
              return (value === 1 ? 'Sim' : 'Não')
            },
            class: 'txtCenter cliEmailPrinc'
          },
          {
            label: 'Ações',
            key: 'actionAcoes',
            class: 'columnActions'
          }
        ],
        fieldsReferencias: [
          {
            key: 'nome',
            label: 'Nome',
            class: 'cliRefNome',
            formatter: this.toCapitalize
          },
          {
            key: 'email',
            label: 'Email',
            class: 'cliRefEmail',
            formatter: this.toLowerCase
          },
          {
            key: 'ddd',
            label: 'DDD',
            class: 'cliRefDDD txtCenter'
          },
          {
            key: 'telefone',
            label: 'Telefone',
            class: 'cliRefTel txtCenter'
          },
          {
            label: 'Ações',
            key: 'actionAcoes',
            class: 'columnActions'
          }
        ],
        fieldsDuplicatas: [
          {
            key: 'numeroPedido',
            label: 'Pedido',
            class: 'cliNumPed'
          },
          {
            key: 'duplicata',
            label: 'Duplicata',
            class: 'txtCenter cliDuplicata'
          },
          {
            key: 'vencimento',
            label: 'Vencimento',
            class: 'txtCenter'
          },
          {
            key: 'valor',
            label: 'Valor R$',
            formatter: valor => {
              return this.formatterValue(valor)
            },
            class: 'txtRight'
          }
        ],
        fieldsUltPed: [
          {
            key: 'numeroPedido',
            label: 'Pedido'
          },
          {
            key: 'emissao',
            label: 'Emissão',
            class: 'txtCenter'
          },
          {
            key: 'status.descricao',
            label: 'Status'
          }
        ],
        operacaoAtual: 0,
        desabilitaIE: false
      }
    },
    methods: {
      toTopOnRefresh: function toTopOnRefresh (event) {
        window.scrollTo(0, 0)
      },
      lengthCnpj: function () {
        if (this.cliente.cnpjCpf.length === 18) {
          let param = this.cliente.cnpjCpf.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('/', '').replace('-', '')
          this.verifCNPJ(param)
        }
      },
      verifCNPJ: function (param) {
        this.blockUiVisibility = true
        clienteService.verificaCNPJ(param).then(response => {
          this.modalClienteExist = true
          this.clienteExistente = response.data
          let parametro = {operacao: operacao.ALTERAR, modo: modo.EDICAO}
          broadcastServer.$emit('pageEditClientes', parametro)
        }).catch(error => {
          console.log(error)
          this.desabilitado = false
          this.operacaoAtual = 0
          // alert('Aconteceu alguma coisa!' + error)
        }).finally(() => {
          this.blockUiVisibility = false
        })
      },
      dadosCliExist: function () {
        this.cliente = this.clienteExistente
      },
      verifClienteIsento: function (event) {
        if (event === 'isento') {
          this.cliente.ieRg = 'ISENTO'
          this.desabilitadoIsento = true
        } else {
          this.cliente.ieRg = ''
          this.desabilitadoIsento = false
        }
      },
      changeEmail: function (emailTemErros) {
        this.emailTemErros = emailTemErros
        // console.log('email tem erros: ' + emailTemErros)
      },
      formatterValue: function (value) {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      },
      toCapitalize: function (value) {
        return value.replace(/\w\S*/g, function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        })
      },
      toLowerCase: function (value) {
        return value.toLowerCase()
      },
      verifLenghtArray: function (array) {
        return !(array.length === 0)
      },
      changePJ: function (event) {
        this.isJuridico = event
        this.isFisica = !event
        this.cliente.tipo = (event === true ? 'J' : 'F')
      },
      changePF: function (event) {
        this.isFisica = event
        this.isJuridico = !event
        this.cliente.tipo = (event === true ? 'F' : 'J')
      },
      pageLista: function () {
        this.modalConfSairSemSalvar = false
        this.isJuridico = true
        this.isFisica = false
        this.cliente = {
          tipo: 'J',
          contatos: [],
          enderecos: [],
          emails: [],
          referenciasComerciais: [],
          duplicatasEmAberto: [],
          ultimosPedidos: [],
          tabelaPreco: {},
          condPagto: '',
          limiteCredito: '',
          valorUtilizado: ''
        }
        this.contato = {
          dataNasc: '',
          telefone: '',
          ddd: '',
          tipoContato: {
            codigo: '',
            chaveErp: '',
            deletado: 0,
            descricao: ''
          },
          dataNascFormat: '',
          chaveErp: '',
          nome: '',
          email: '',
          codCliente: ''
        }
        this.endereco = {
          uf: '',
          cidade: '',
          complemento: '',
          numero: '',
          bairro: '',
          logradouro: '',
          latitude: 0,
          chaveErp: '',
          tipoEndereco: {
            principal: 0,
            codigo: '',
            chaveErp: '',
            deletado: 0,
            descricao: ''
          },
          enderecoCompleto: '',
          cep: '',
          longitude: 0
        }
        this.email = {
          tipoEmail: {
            principal: 0,
            codigo: '',
            chaveErp: '',
            deletado: 0,
            descricao: ''
          },
          chaveErp: '',
          email: ''
        }
        this.referencia = {
          telefone: '',
          ddd: '',
          chaveErp: '',
          nome: '',
          email: ''
        }
        this.showDismissibleAlert = false
        this.errosLabels = []
        this.errors.clear()
        this.$validator.reset()
        let parametro = {operacao: operacao.ALTERAR, modo: modo.LISTA}
        broadcastServer.$emit('pageEditClientes', parametro)
        // let parametros = {termo: '', uf: '', cidade: ''}
        // console.log(JSON.stringify(parametros))
        // broadcastServer.$emit('parametrosSelecionadosCliente', parametros)
      },
      clearContato: function () {
        this.contato = {
          dataNasc: '',
          telefone: '',
          ddd: '',
          tipoContato: {
            codigo: '',
            chaveErp: '',
            deletado: 0,
            descricao: ''
          },
          dataNascFormat: '',
          chaveErp: '',
          nome: '',
          email: '',
          codCliente: ''
        }
      },
      clearEndereco: function () {
        this.endereco = {
          uf: '',
          cidade: '',
          complemento: '',
          numero: '',
          bairro: '',
          logradouro: '',
          latitude: 0,
          chaveErp: '',
          tipoEndereco: {
            principal: 0,
            codigo: '',
            chaveErp: '',
            deletado: 0,
            descricao: ''
          },
          enderecoCompleto: '',
          cep: '',
          longitude: 0
        }
      },
      clearEmail: function () {
        this.email = {
          tipoEmail: {
            principal: 0,
            codigo: '',
            chaveErp: '',
            deletado: 0,
            descricao: ''
          },
          chaveErp: '',
          email: ''
        }
      },
      clearReferencia: function () {
        this.referencia = {
          telefone: '',
          ddd: '',
          chaveErp: '',
          nome: '',
          email: ''
        }
      },
      newContato: function () {
        this.incluirContato = true
        this.clearContato()
        this.novoContato = true
        this.modalContato = true
      },
      newEndereco: function () {
        this.clearEndereco()
        this.novoEndereco = true
        this.modalEndereco = true
      },
      newEmail: function () {
        this.clearEmail()
        this.novoEmail = true
        this.modalEmail = true
      },
      newReferencia: function () {
        this.clearReferencia()
        this.novaReferencia = true
        this.modalReferencia = true
      },
      addCont: function () {
        if (this.novoContato) {
          this.cliente.contatos.push(this.contato)
          this.modalContato = false
          this.clearContato()
        } else {
          this.cliente.contatos[this.indiceContatoSelecionado].nome = this.contato.nome
          this.cliente.contatos[this.indiceContatoSelecionado].email = this.contato.email
          this.cliente.contatos[this.indiceContatoSelecionado].dataNascFormat = this.contato.dataNascFormat
          this.cliente.contatos[this.indiceContatoSelecionado].ddd = this.contato.ddd
          this.cliente.contatos[this.indiceContatoSelecionado].telefone = this.contato.telefone
          this.cliente.contatos[this.indiceContatoSelecionado].tipoContato = this.contato.tipoContato
          this.clearContato()
        }
      },
      addEnd: function (event) {
        this.endereco.enderecoCompleto = this.endereco.logradouro + ', ' + this.endereco.numero + ', ' + this.endereco.bairro + ' - ' + this.endereco.cidade + ' - ' + this.endereco.uf
        if (this.novoEndereco) {
          let enderecos = this.cliente.enderecos.filter(end => end.tipoEndereco.codigo === this.endereco.tipoEndereco.codigo)
          if (enderecos.length > 0) {
            event.preventDefault()
            alert('Este tipo de endereço já foi adicionado, por favor, selecione outro tipo')
          } else {
            this.cliente.enderecos.push(this.endereco)
            this.modalEndereco = false
            this.clearEndereco()
          }
        } else {
          this.cliente.enderecos[this.indiceEnderecoSelecionado].uf = this.endereco.uf
          this.cliente.enderecos[this.indiceEnderecoSelecionado].cidade = this.endereco.cidade
          this.cliente.enderecos[this.indiceEnderecoSelecionado].complemento = this.endereco.complemento
          this.cliente.enderecos[this.indiceEnderecoSelecionado].numero = this.endereco.numero
          this.cliente.enderecos[this.indiceEnderecoSelecionado].bairro = this.endereco.bairro
          this.cliente.enderecos[this.indiceEnderecoSelecionado].logradouro = this.endereco.logradouro
          this.cliente.enderecos[this.indiceEnderecoSelecionado].latitude = this.endereco.latitude
          this.cliente.enderecos[this.indiceEnderecoSelecionado].chaveErp = this.endereco.chaveErp
          this.cliente.enderecos[this.indiceEnderecoSelecionado].tipoEndereco = this.endereco.tipoEndereco
          this.cliente.enderecos[this.indiceEnderecoSelecionado].enderecoCompleto = this.endereco.enderecoCompleto
          this.cliente.enderecos[this.indiceEnderecoSelecionado].cep = this.endereco.cep
          this.cliente.enderecos[this.indiceEnderecoSelecionado].longitude = this.endereco.longitude
          this.clearEndereco()
        }
      },
      addEmail: function () {
        if (this.novoEmail) {
          this.cliente.emails.push(this.email)
          this.modalEmail = false
          this.clearEmail()
        } else {
          this.cliente.emails[this.indiceEmailSelecionado].chaveErp = this.email.chaveErp
          this.cliente.emails[this.indiceEmailSelecionado].tipoEmail = this.email.tipoEmail
          this.cliente.emails[this.indiceEmailSelecionado].email = this.email.email
          this.clearEmail()
        }
      },
      addRef: function () {
        if (this.novaReferencia) {
          this.cliente.referenciasComerciais.push(this.referencia)
          this.modalReferencia = false
          this.clearReferencia()
        } else {
          this.cliente.referenciasComerciais[this.indiceReferenciaSelecionado].telefone = this.referencia.telefone
          this.cliente.referenciasComerciais[this.indiceReferenciaSelecionado].ddd = this.referencia.ddd
          this.cliente.referenciasComerciais[this.indiceReferenciaSelecionado].chaveErp = this.referencia.chaveErp
          this.cliente.referenciasComerciais[this.indiceReferenciaSelecionado].nome = this.referencia.nome
          this.cliente.referenciasComerciais[this.indiceReferenciaSelecionado].email = this.referencia.email
          this.clearReferencia()
        }
      },
      alterContato: function (indiceArrayContato) {
        this.incluirContato = false
        this.novoContato = false
        let contato = this.cliente.contatos[indiceArrayContato]
        this.indiceContatoSelecionado = indiceArrayContato
        this.clearContato()
        this.modalContato = true
        var editContato = Object.assign({}, contato)
        this.contato = editContato
      },
      alterEndereco: function (indiceArrayEndereco) {
        this.novoEndereco = false
        let endereco = this.cliente.enderecos[indiceArrayEndereco]
        this.indiceEnderecoSelecionado = indiceArrayEndereco
        this.clearEndereco()
        this.modalEndereco = true
        var editEndereco = Object.assign({}, endereco)
        this.endereco = editEndereco
      },
      alterEmail: function (indiceArrayEmail) {
        this.novoEmail = false
        let email = this.cliente.emails[indiceArrayEmail]
        this.indiceEmailSelecionado = indiceArrayEmail
        this.clearEmail()
        this.modalEmail = true
        var editEmail = Object.assign({}, email)
        this.email = editEmail
      },
      alterReferencia: function (indiceArrayReferencia) {
        this.novaReferencia = false
        let referencia = this.cliente.referenciasComerciais[indiceArrayReferencia]
        this.indiceReferenciaSelecionado = indiceArrayReferencia
        this.clearReferencia()
        this.modalReferencia = true
        var editReferencia = Object.assign({}, referencia)
        this.referencia = editReferencia
      },
      askExcluirContato: function (indiceArrayContato) {
        this.modalExcluirContato = true
        this.indiceArrayContato = indiceArrayContato
      },
      askExcluirEndereco: function (indiceArrayEndereco) {
        this.modalExcluirEndereco = true
        this.indiceArrayEndereco = indiceArrayEndereco
      },
      askExcluirEmail: function (indiceArrayEmail) {
        this.modalExcluirEmail = true
        this.indiceArrayEmail = indiceArrayEmail
      },
      askExcluirReferencia: function (indiceArrayReferencia) {
        this.modalExcluirReferencia = true
        this.indiceArrayReferencia = indiceArrayReferencia
      },
      excluirContato: function () {
        this.modalExcluirContato = false
        this.novoContato = false
        this.cliente.contatos.splice(this.indiceArrayContato, 1)
        this.indiceContatoSelecionado = -1
        this.modalContato = false
        this.indiceArrayContato = ''
        this.modalItemExcluido = true
      },
      excluirEndereco: function () {
        this.modalExcluirEndereco = false
        this.novoEndereco = false
        this.cliente.enderecos.splice(this.indiceArrayEndereco, 1)
        this.indiceEnderecoSelecionado = -1
        this.modalEndereco = false
        this.indiceArrayEndereco = ''
        this.modalItemExcluido = true
      },
      excluirEmail: function () {
        this.modalExcluirEmail = false
        this.novoEmail = false
        this.cliente.emails.splice(this.indiceArrayEmail, 1)
        this.indiceEmailSelecionado = -1
        this.modalEmail = false
        this.indiceArrayEmail = ''
        this.modalItemExcluido = true
      },
      excluirReferencia: function () {
        this.modalExcluirReferencia = false
        this.novaReferencia = false
        this.cliente.referenciasComerciais.splice(this.indiceArrayReferencia, 1)
        this.indiceReferenciaSelecionado = -1
        this.modalReferencia = false
        this.indiceArrayReferencia = ''
        this.modalItemExcluido = true
      },
      disableSalvarContato: function () {
        if (this.incluirContato === true) {
          if (this.contato.nome === '' || this.contato.tipoContato.codigo === '' || this.contato.ddd.length < 4 || this.contato.telefone.length < 9 || this.emailTemErros === true) {
            return true
          }
          return false
        } else {
          if (this.contato.nome === '' || this.contato.tipoContato.codigo === '' || this.contato.ddd.length < 2 || this.contato.telefone.length < 9) {
            return true
          }
          return false
        }
      },
      disableSalvarEndereco: function () {
        if (this.endereco.uf === '' || this.endereco.cidade === '' || this.endereco.numero === '' || this.endereco.logradouro === '' || this.endereco.tipoEndereco.codigo === '' || this.endereco.cep === '' || this.endereco.cep.length < 9) {
          return true
        }
        return false
      },
      disableSalvarEmail: function () {
        if (this.email.email === '' || this.email.tipoEmail.codigo === '' || this.emailTemErros === true) {
          return true
        }
        return false
      },
      disableSalvarReferencia: function () {
        if (this.referencia.nome === '' || this.referencia.ddd === '' || this.referencia.telefone === '' || this.referencia.ddd.length < 4 || this.referencia.telefone.length < 9 || this.emailTemErros === true) {
          return true
        }
        return false
      },
      formatDates: function (dateOne, dateTwo) {
        let formattedDates = ''
        if (dateOne) {
          this.dataDe = dateOne
          let dataFormatada = dateOne.substring(8, 10) + '/' + dateOne.substring(5, 7) + '/' + dateOne.substring(0, 4)
          formattedDates = dataFormatada // dateFns.format(dateOne, this.dateFormat)
        }
        if (dateTwo) {
          this.dataAte = dateTwo
          let dataFormatada = dateTwo.substring(8, 10) + '/' + dateTwo.substring(5, 7) + '/' + dateTwo.substring(0, 4)
          formattedDates += ' - ' + dataFormatada // dateFns.format(dateTwo, this.dateFormat)
        }
        return formattedDates
      },
      onClosed: function () {
        // let datesStr = this.formatDates(this.inputDateOne, this.inputDateTwo)
        // console.log('Dates Selected: ' + datesStr)
        this.trigger = false
      },
      onMonthChange: function (dates) {
        // console.log('months changed', dates)
      },
      validaDados: function () {
        this.errosLabels = []
        if (this.cliente.enderecos.length > 0) {
          let filterTipoEnd = this.cliente.enderecos
          .map((item) => item)
          this.filterTipoEnd = filterTipoEnd
          .filter(function (tipo) {
            return tipo.tipoEndereco.principal === 1
          })
        }
        if (this.cliente.emails.length > 0) {
          let filterTipoEmail = this.cliente.emails
          .map((item) => item)
          this.filterTipoEmail = filterTipoEmail
          .filter(function (tipo) {
            return tipo.tipoEmail.principal === 1
          })
        }
        var retorno = true
        if (typeof this.cliente.fantasia === 'undefined' || this.cliente.fantasia === '') {
          retorno = false
          this.errosLabels.push({message: 'O campo Fantasia é obrigatório, favor preencher corretamente'})
          this.showDismissibleAlert = true
        }
        if (typeof this.cliente.razaoSocial === 'undefined' || this.cliente.razaoSocial === '') {
          retorno = false
          this.errosLabels.push({message: 'O campo Razão Social é obrigatório, favor preencher corretamente'})
          this.showDismissibleAlert = true
        }
        if (this.cliente.tipo === 'J' && typeof this.cliente.cnpjCpf === 'undefined') {
          retorno = false
          this.errosLabels.push({message: 'O campo CNPJ é obrigatório, favor preencher corretamente'})
          this.showDismissibleAlert = true
        } else if (this.cliente.tipo === 'J' && this.cliente.cnpjCpf.length < 18) {
          retorno = false
          this.errosLabels.push({message: 'O campo CNPJ é obrigatório e deve conter 18 caracteres, favor preencher corretamente'})
          this.showDismissibleAlert = true
        }
        // if (typeof this.cliente.ieRg !== 'undefined') {
        //   if (this.cliente.ieRg.length > 0 && this.cliente.ieRg.length < 15) {
        //     retorno = false
        //     this.errosLabels.push({message: 'O campo Inscrição Estadual deve conter 12 caracteres, favor preencher corretamente'})
        //     this.showDismissibleAlert = true
        //   }
        // }
        if (this.cliente.tipo === 'F' && typeof this.cliente.cnpjCpf === 'undefined') {
          retorno = false
          this.errosLabels.push({message: 'O campo CPF é obrigatório, favor preencher corretamente'})
          this.showDismissibleAlert = true
        } else if (this.cliente.tipo === 'F' && this.cliente.cnpjCpf.length < 14) {
          retorno = false
          this.errosLabels.push({message: 'O campo CPF é obrigatório e deve conter 14 caracteres, favor preencher corretamente'})
          this.showDismissibleAlert = true
        }
        if (typeof this.cliente.ddd === 'undefined') {
          retorno = false
          this.errosLabels.push({message: 'O campo DDD é obrigatório, favor preencher corretamente'})
          this.showDismissibleAlert = true
        } else if (this.cliente.ddd.length < 4) {
          retorno = false
          this.errosLabels.push({message: 'O campo DDD é obrigatório e deve conter 4 caracteres, favor preencher corretamente'})
          this.showDismissibleAlert = true
        }
        if (typeof this.cliente.telefone === 'undefined') {
          retorno = false
          this.errosLabels.push({message: 'O campo Telefone é obrigatório, favor preencher corretamente'})
          this.showDismissibleAlert = true
        } else if (this.cliente.telefone.length < 9) {
          retorno = false
          this.errosLabels.push({message: 'O campo Telefone é obrigatório e deve conter ao menos 8 caracteres, favor preencher corretamente'})
          this.showDismissibleAlert = true
        }
        if (typeof this.cliente.tabelaPreco.codigo === 'undefined') {
          retorno = false
          this.errosLabels.push({message: 'O campo Tabela Preço é obrigatório, favor selecionar uma opção válida'})
          this.showDismissibleAlert = true
        }
        // if (this.emailTemErros === true) {
        //   retorno = false
        //   this.errosLabels.push({message: 'O campo Email contém erros, favor preencher corretamente'})
        //   this.showDismissibleAlert = true
        // }
        if (this.filterTipoEnd.length === 0) {
          retorno = false
          this.errosLabels.push({message: 'Ao menos um Endereço tipo Fiscal deve ser cadastrado'})
          this.showDismissibleAlert = true
        }
        if (this.filterTipoEmail.length === 0) {
          retorno = false
          this.errosLabels.push({message: 'Ao menos um Email tipo NFE deve ser cadastrado'})
          this.showDismissibleAlert = true
        }
        // if (this.filterTipoEnd.length === 0) {
        //   retorno = false
        //   // sinaliza input filterTipoEnd
        // }
        // if (this.filterTipoEmail.length === 0) {
        //   retorno = false
        //   // sinaliza input filterTipoEmail
        // }
        return retorno
      },
      confSairSemSalvar: function () {
        this.modalConfSairSemSalvar = true
      },
      confirmaSalvar: function () {
        this.modalConfSalvarCliente = true
      },
      salvarCliente: function () {
        this.modalConfSalvarCliente = false
        // console.log(this.cliente)
        if (this.validaDados()) {
          if (this.errosLabels.length === 0) {
            this.showDismissibleAlert = false
          }
          let novosContatos = []
          for (var iContato = 0; iContato < this.cliente.contatos.length; iContato++) {
            let contato = this.cliente.contatos[iContato]
            novosContatos.push({
              dataNasc: contato.dataNasc,
              telefone: contato.telefone.replace('-', ''),
              tipoContato: contato.tipoContato.codigo,
              chaveErp: contato.chaveErp,
              email: contato.email,
              ddd: contato.ddd.replace('(', '').replace(')', ''),
              nome: contato.nome
            })
          }
          let novosEnderecos = []
          for (var iEndereco = 0; iEndereco < this.cliente.enderecos.length; iEndereco++) {
            let endereco = this.cliente.enderecos[iEndereco]
            novosEnderecos.push({
              bairro: endereco.bairro,
              chaveErp: endereco.chaveErp,
              cidade: endereco.cidade,
              uf: endereco.uf,
              complemento: endereco.complemento,
              principal: 0,
              tipoEndereco: endereco.tipoEndereco.codigo,
              numero: endereco.numero,
              latitude: 0,
              logradouro: endereco.logradouro,
              longitude: 0,
              cep: endereco.cep.replace('-', '')
            })
          }
          let novosEmails = []
          for (var iEmail = 0; iEmail < this.cliente.emails.length; iEmail++) {
            let email = this.cliente.emails[iEmail]
            novosEmails.push({
              principal: 0,
              tipoEmail: email.tipoEmail.codigo,
              chaveErp: email.chaveErp,
              email: email.email
            })
          }
          let novasReferencias = []
          for (var iReferencia = 0; iReferencia < this.cliente.referenciasComerciais.length; iReferencia++) {
            let referencia = this.cliente.referenciasComerciais[iReferencia]
            novasReferencias.push({
              chaveErp: referencia.chaveErp,
              telefone: referencia.telefone.replace('-', ''),
              ddd: referencia.ddd.replace('(', '').replace(')', ''),
              nome: referencia.nome,
              email: referencia.email
            })
          }
          if (this.operacaoAtual === 0) {
            let clienteSalvar = {
              razaoSocial: this.cliente.razaoSocial,
              tipo: this.cliente.tipo,
              fantasia: this.cliente.fantasia,
              grupoTributario: '',
              telefone: this.cliente.telefone.replace('-', ''),
              tabelaPreco: this.cliente.tabelaPreco.codigo,
              idClienteGoSales: 0,
              ieRg: this.cliente.ieRg.replace('.', '').replace('.', '').replace('.', ''),
              condPagto: this.cliente.condPagto,
              chaveErp: '',
              suframa: '',
              cnpjCpf: this.cliente.cnpjCpf.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('/', '').replace('-', ''),
              codCliente: '',
              valorUtilizado: 0,
              ddd: this.cliente.ddd.replace('(', '').replace(')', ''),
              limiteCredito: 0,
              enderecos: novosEnderecos,
              emails: novosEmails,
              referenciasComerciais: novasReferencias,
              contatos: novosContatos
            }
            // console.log(JSON.stringify(clienteSalvar))
            this.blockUiVisibility = true
            clienteService.salvar(clienteSalvar).then(response => {
              // console.log(response)
            }).catch(error => {
              console.log(error)
              alert('Aconteceu alguma coisa!' + error)
            }).finally(() => {
              this.blockUiVisibility = false
              this.modalClienteSalvo = true
            })
            // console.log(this.cliente)
          } else {
            let clienteSalvar = {
              razaoSocial: this.cliente.razaoSocial,
              tipo: this.cliente.tipo,
              fantasia: this.cliente.fantasia,
              grupoTributario: '',
              telefone: this.cliente.telefone.replace('-', ''),
              tabelaPreco: this.cliente.tabelaPreco.codigo,
              idClienteGoSales: this.cliente.idClienteGoSales,
              ieRg: this.cliente.ieRg.replace('.', '').replace('.', '').replace('.', ''),
              condPagto: this.cliente.condPagto,
              chaveErp: this.cliente.chaveErp,
              suframa: this.cliente.suframa,
              cnpjCpf: this.cliente.cnpjCpf.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('/', '').replace('-', ''),
              codCliente: this.cliente.codCliente,
              valorUtilizado: this.cliente.valorUtilizado,
              ddd: this.cliente.ddd.replace('(', '').replace(')', ''),
              limiteCredito: this.cliente.limiteCredito,
              enderecos: novosEnderecos,
              emails: novosEmails,
              referenciasComerciais: novasReferencias,
              contatos: novosContatos
            }
            // console.log(JSON.stringify(clienteSalvar))
            this.blockUiVisibility = true
            clienteService.salvar(clienteSalvar).then(response => {
              // console.log(response)
            }).catch(error => {
              console.log(error)
              alert('Aconteceu alguma coisa!' + error)
            }).finally(() => {
              this.blockUiVisibility = false
              this.modalClienteSalvo = true
            })
          }
          // console.log('true')
        } else {
          // console.log('false')
        }
      }
    },
    created () {
      window.addEventListener('beforeunload', this.toTopOnRefresh)
      broadcastServer.$on('pageEditClientes', parametro => {
        window.scrollTo(0, 0)
        // console.log(parametro)
        if (parametro.operacao === 'adicionar') {
          this.operacaoAtual = 0 // 0 NOVO CLIENTE
          this.desabilitado = false
          this.desabilitaIE = false
          this.clienteIeIsento = false
          this.desabilitadoIsento = false
          this.limiteCredito = '0,00'
          this.valorUtilizado = '0,00'
          this.cliente = {
            tipo: 'J',
            contatos: [],
            enderecos: [],
            emails: [],
            referenciasComerciais: [],
            duplicatasEmAberto: [],
            ultimosPedidos: [],
            tabelaPreco: {},
            limiteCredito: '',
            valorUtilizado: ''
          }
          // console.log(this.desabilitaIE)
        } else {
          this.desabilitado = true
          this.operacaoAtual = 1 // 0 ALTERA CLIENTE
          if (this.cliente.ieRg !== '') {
            this.desabilitaIE = true
          } else {
            this.desabilitaIE = false
            this.clienteIeIsento = false
            this.desabilitadoIsento = false
          }
          // console.log(this.desabilitaIE)
        }
      })
      broadcastServer.$on('pageEditClienteResponse', parametro => {
        window.scrollTo(0, 0)
        // console.log(parametro)
        this.cliente = parametro
        if (parametro.tipo === 'J') {
          this.isJuridico = true
          this.isFisica = false
        } else {
          this.isJuridico = false
          this.isFisica = true
        }
        this.cliente.duplicatasEmAberto = parametro.duplicatasEmAberto.sort((a, b) => (a.vencimentoOrdem > b.vencimentoOrdem) ? 1 : ((b.vencimentoOrdem > a.vencimentoOrdem) ? -1 : 0))
        this.cliente.ultimosPedidos = parametro.ultimosPedidos.sort((a, b) => (b.emissaoOrdem > a.emissaoOrdem) ? 1 : ((a.emissaoOrdem > b.emissaoOrdem) ? -1 : 0))
      })
      clienteService.selecionar().then(response => {
        this.blockUiVisibility = true
        this.dadosTabela = response.data
        // console.log(response)
      }).catch(error => {
        console.log(error)
        alert('Aconteceu alguma coisa!' + error)
      }).finally(() => {
        this.blockUiVisibility = false
      })
      let today = new Date()
      let dd = String(today.getDate()).padStart(2, '0')
      let mm = String(today.getMonth() + 1).padStart(2, '0')
      let yyyy = today.getFullYear()
      this.dataAtual = mm + '/' + dd + '/' + yyyy
    }
  }
</script>
<style scoped>
  .b-table th {
    background: #eee;
  }
  .btn {
    width: inherit;
  }
  .form-group {
    margin-bottom: 0;
  }
  #formCliente {
    text-align: left
  }
  .title {
    font-weight: 600;
    text-align: left;
    font-family: 'Didact Gothic', sans-serif;
  }
  .titleFluid {
    padding: 0;
    font-weight: 600;
    text-align: left;
    font-family: 'Didact Gothic', sans-serif;
    font-size: 20px;
  }
  .titleFluid:before {
    content: "";
    border-bottom: 1px solid;
    width: 100%;
    position: absolute;
    top: 16px;
    color: #e3e3e3;
  }
  .titleFluid p {
    margin: 0;
    position: relative;
    float: left;
    background: #fff;
    padding-right: 20px;
  }
  .btn-circle {
    width: 35px;
    height: 35px;
    padding: 0;
    border-radius: 50%;
    text-align: center;
    font-size: 12px;
    line-height: initial;
  }
  hr {
    background: #000;
    margin: 2.5rem 0;
  }
  #boxLimite {
    margin: 0 0 20px !important;
  }
  #boxLimite > div,
  #semPedidos {
    padding: 10px 0;
    background: #eee;
    text-align: center;
    border: 1px solid #d2d2d2;
  }
  .modal-body .row > div {
    padding: 0 10px;
  }
  .modal-body .row > div:first-child {
    padding: 0 10px 0 0;
  }
  .modal-body .row > div:last-child {
    padding: 0 0 0 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/items/TableEditClientesVue.vue